const positionTopRight = () => `
    position: absolute;
    top: 0;
    right: 0;
`;

export {positionTopRight};
